// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    [theme.breakpoints.down(750)]: {
      marginTop: 15,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '0 !important',
  },
  buttonStyle: {
    width: 200,
    margin: '15px auto',
  },
  error: {
    margin: 10,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  statusOk: {
    color: GlobalStyles.color.COLOR_GREEN,
  },
  statusError: {
    color: GlobalStyles.color.COLOR_REJECT,
  },
});

export default styles;
